import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {withRouter} from 'react-router-dom';
import Loader from '../Loader/Loader';
import TopMenu from '../TopMenu/TopMenu';
import RootModal from '../../containers/RootModal';
import {isAvalibleBrowser} from '../../providers/BrowserProvider';
import NotSupportedBrowser from '../NotSupportedBrowser/NotSupportedBrowser';
import './App.scss';

class App extends Component {
    
    render() {
        if (this.props.initialData.isLoading===true) {
            return <Loader />;
        }
        else {
            return (
                <div>
                    <TopMenu />
                    <div className="col-xs-12 container main-container main-div">
                        <RootModal />
                        {isAvalibleBrowser() && <div> {this.props.children} </div>}
                        {!isAvalibleBrowser() && <NotSupportedBrowser />}
                    </div>
                </div>
            );
        }
    }
}

App.propTypes = {
        children: PropTypes.node,
        initialData: PropTypes.object
    };

const mapStateToProps = (state, ownProps) => {
    return {
        initialData: state.initialData,
        children: ownProps.children
    };
};

export default withRouter(connect(mapStateToProps, null)(App));


// WEBPACK FOOTER //
// ./src/components/App/App.js